<template>
  <div>
    <div>
      HELLO WORLD SAE Reporting
    </div>

  </div>
</template>

<script>

export default {
  name: 'SAEReporting',
  components: {

  },
  data () {
    return {

    }
  },
  /// ////
  computed: {

  },
  /// ////
  mounted: function () {

  },
  /// ////
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }

  }
}

</script>
<style>

</style>
